import { http } from "../http";

export interface Files {
    fileDetailsList: [
        {
            fileBase64 : string;
            pmtid : string;
            fileName : string;
            mimeType : string;
        }
    ];
};

export const uploadFile = async (sendData: Files): Promise<Files> => {
    const { data } = await http.post<Files>("file/savedocuments", sendData);
    return data;
};

export const getFileByPmid = async (pmtid: string): Promise<Files> => {
    const { data } = await http.get<Files>(`file/getsaveddocuments?pmtid=${pmtid}`);
    return data;
};

export const getFileByIbanRef = async (ibankref: string): Promise<Files> => {
    const { data } = await http.get<Files>(`file/getsaveddocuments?ibankref=${ibankref}`);
    return data;
};

export const deleteFileById = async (ibankref: string): Promise<any> => {
    const { data } = await http.post<any>(`/file/deletedocuments/${ibankref}`);
    return data;
};


